// Authentic Gwenn ha Du (Breton flag) — black & white only, no blue.
// 9 horizontal bands (5 black, 4 white) + white canton with black ermine spots.
const ERMINE_POS = [
  [7, 6], [15, 6], [23, 6],
  [11, 13], [19, 13],
  [7, 20], [15, 20], [23, 20],
];

const Ermine = ({ x, y }) => (
  <g transform={`translate(${x} ${y}) scale(0.9)`} fill="#111111">
    <path d="M0 3 C-1.6 3 -2.4 1.4 -1.5 0.2 L-0.7 -1.4 C-0.35 -2.1 0.35 -2.1 0.7 -1.4 L1.5 0.2 C2.4 1.4 1.6 3 0 3 Z" />
    <circle cx="-1.1" cy="-2.3" r="0.62" />
    <circle cx="0" cy="-3" r="0.62" />
    <circle cx="1.1" cy="-2.3" r="0.62" />
  </g>
);

export const BretonFlag = ({ className = "h-8" }) => {
  const stripe = 60 / 9;
  return (
    <svg viewBox="0 0 90 60" className={`${className} w-auto`} role="img" aria-label="Drapeau breton Gwenn ha Du">
      <rect width="90" height="60" fill="#ffffff" />
      {[0, 2, 4, 6, 8].map((i) => (
        <rect key={i} x="0" y={i * stripe} width="90" height={stripe} fill="#111111" />
      ))}
      {/* Canton */}
      <rect x="0" y="0" width="33" height={stripe * 5} fill="#ffffff" />
      {ERMINE_POS.map(([x, y], i) => (
        <Ermine key={i} x={x} y={y} />
      ))}
    </svg>
  );
};

export default BretonFlag;
